export var COLUMN_CHART_PERIODS = [{
  id: 'M0',
  label: 'en el año'
}, {
  id: 'M12',
  label: 'a 12 meses'
}, {
  id: 'M36',
  label: 'a 36 meses'
}, {
  id: 'M60',
  label: 'a 60 meses'
}];